import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useContext, useEffect, useState } from "react";
import PastEvents from "../../components/events/PastEvents";
import UpComingEvents from "../../components/events/UpComingEvens";
import { StoreContext } from "../../Context/StoreContext";
import Button from "../Button";
import Close from "../Icons/Close";
import Loader from "../Loader";
import { getRoomAllEvents } from "../../actions/eventActions";
import moment from "moment";

export default function AllEventModel({
  roomId,
  isOpen,
  setIsOpen,
  upcomingEvents,
}) {
  const currntTime = moment().format();
  const filterUpcomingEvents = upcomingEvents.filter(
    (event) =>
      !(
        moment(event.startDate).format() < currntTime &&
        moment(event.endDate).format() > currntTime
      )
  );

  const { state, dispatch } = useContext(StoreContext);

  const [isFetching, setIsFetching] = useState(false);
  const {
    auth: { user },
    event: {
      roomPastEvents,
      isRoomAllEventFetching,
      isRoomAllEventMore,
      roomAllEventOffset,
    },
  } = state;
  useEffect(() => {
    setIsFetching(true);
    getRoomAllEvents(user?.token, dispatch, roomId, false, 0).then(() => {
      setIsFetching(false);
    });
  }, []);

  const handleLoadMoreRoomEvents = async () => {
    await getRoomAllEvents(
      user?.token,
      dispatch,
      roomId,
      isRoomAllEventMore,
      roomAllEventOffset
    );
  };
  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-40 overflow-y-auto"
          onClose={() => setIsOpen(false)}
        >
          <div className="flex md:items-end items-center justify-center min-h-screen pt-4 px-4  pb-0 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-overlay bg-opacity-75 transition-opacity" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
              tabIndex={0}
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block align-bottom bg-white dark:bg-navyGray rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-428px h-full font-ubuntu">
                <div className="bg-white dark:bg-navyGray p-4 border-b border-frescoWhite dark:border-matteGray">
                  <div className="flex justify-between items-center">
                    <p className="font-medium text-lg text-black dark:text-frescoWhite tracking-wide">
                      All Events
                    </p>
                    <span
                      className="bg-frescoWhite p-9px rounded-full cursor-pointer"
                      onClick={() => {
                        setIsOpen(false);
                      }}
                    >
                      <Close />
                    </span>
                  </div>
                </div>
                {isFetching ? (
                  <div className="py-4">
                    <Loader />
                  </div>
                ) : filterUpcomingEvents?.length + roomPastEvents?.length ===
                  0 ? (
                  <div className="py-4 text-center text-matteGray dark:text-frescoWhite">
                    No events
                  </div>
                ) : (
                  <div>
                    <div className="px-4 overflow-y-auto custom-scrollbar h-96">
                      <div className="pt-4">
                        <UpComingEvents events={filterUpcomingEvents} />
                      </div>

                      <div className="pt-4">
                        <PastEvents events={roomPastEvents} />
                      </div>
                      <div className="flex justify-center">
                        {isFetching ? undefined : !isRoomAllEventFetching ? (
                          isRoomAllEventMore && (
                            <div className="pt-2 flex justify-center">
                              <Button
                                size="vibhut-sm"
                                variant="vibhut-secondary"
                                onClick={handleLoadMoreRoomEvents}
                              >
                                Load More
                              </Button>
                            </div>
                          )
                        ) : (
                          <div className="pt-2 md:flex justify-center">
                            <Loader />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className=" px-4 py-3 flex flex-row-reverse ">
                      <div className="mr-3">
                        <Button
                          onClick={() => setIsOpen(false)}
                          size="vibhut-sm"
                          variant="vibhut-primary"
                        >
                          Okay
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
